import objectUtils from '../utils/object-utils'

export default class ProviderOrderDiff {
  constructor (options = {}) {
    this.model = 'ProviderOrderDiff'

    this.id = objectUtils.get(options, 'id', null)
    this.provider_alias = objectUtils.get(options, 'provider_alias', null)
    this.order_id = objectUtils.get(options, 'order_id', null) // RouteLeaf order ID
    this.order_number = objectUtils.get(options, 'order_number', null) // RouteLeaf order number
    this.thirdparty_order_id = objectUtils.get(options, 'thirdparty_order_id', null) // Provider order ID
    this.thirdparty_status = objectUtils.get(options, 'thirdparty_status', null) // Provider order status
    this.diff = objectUtils.get(options, 'diff', null)
    this.compared_at = objectUtils.get(options, 'compared_at', null)
  }
}
